﻿import React, { useState, useEffect, Fragment, useRef } from 'react';
import { Link } from "react-router-dom";
import { useDebounce } from 'hooks/useDebounce';
import { FormCheckbox, FormDateRangeInput, FormLocationSelector, FormTextInput } from 'components/form-fields';
import { Button } from 'components/buttons'
import { ListingTable } from "components/listing";
import { PageRestricted } from 'pages/errors/page-restricted';
import { UserAccess, UserHasAccess } from 'components/user-access';
import { JobService, LocationService } from 'services';
import { ShowHide } from "components/layout";
import moment from "moment";
import { Tooltip } from 'components/tooltip';
import { Filter, FilterButton } from 'components/filtering';
import { useSelector, useDispatch } from 'react-redux';
import { SetFiltering } from 'state/actions';
import { DateToLocal } from "components/dates";
import { AlertConfirm, NotificationToaster } from "components/notifications";
import { useValidation } from "hooks/useValidation";
import { Intent } from '@blueprintjs/core';
import { StatusBlock } from "components/status";
import { CancelJob, BulkEditJob } from 'pages/job/edit/shared';
import './JobListing.css';
import axios from 'axios';
import { HelperFunctions, JobHelperFunctions } from 'helpers';
import PropTypes from 'prop-types';

export function JobListingStandard(
    {
        loading = false,
        filters,
        isLoading,
        reload,
        reloadRequired,
        requiredAction
    }
) {

    const defaultRecordSize = 25;
    const debounceTimeout = 750;
    const flsStatusFilter = 3;

    const [totalRecords, setTotalRecords] = useState(0);
    const [tableRows, setTableRows] = useState([]);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(defaultRecordSize);
    const [loadingData, setLoadingData] = useState(true);
    const [savingData, setSavingData] = useState(false);
    const [locationSetUp, setLocationSetUp] = useState(false);
    const [dateSetUp, setDateSetUp] = useState(false);
    const [tableSortBy, setTableSortBy] = useState({ headerName: "Date", sortName: "COMPLETEDSCHEDULEDUEDDATE" });
    const [tableSortDir, setTableSortDir] = useState("D");
    const [showFilters, setShowFilters] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState([]);
    const [pageFilters, setPageFilters] = useState([]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [showAcknowledge, setShowAcknowledge] = useState(false);
    const [currentJobId, setCurrentJobId] = useState(-1);
    const [searchTerm, setSearchTerm] = useState("");
    const debouncedSearchTerm = useDebounce(searchTerm, debounceTimeout);
    const [isValid, errors, validate] = useValidation();
    const [acknowledgedOnBehalfOf, setAcknowledgedOnBehalfOf] = useState({
        acknowledgedOnBehalfOf: ""
    });
    const [selectAllJobs, setSelectAllJobs] = useState(false);
    const [selectAllJobsToCancel, setSelectAllJobsToCancel] = useState(false);
    const [tableHeaders, setTableHeaders] = useState([]);
    const [locationList, setLocationList] = useState({ location: [], hierarchy: [] });
    const [bulkEditlocationList, setBulkEditLocationList] = useState({ location: [], hierarchy: [] });
    const acknowledgedOnBehalfOfInputRef = useRef(null);
    const searchInputRef = useRef(null);
    const canAccessPage = UserHasAccess(requiredAction);
    const isInternal = UserHasAccess("Internal");
    const noDataMessage = "No visits found.";
    const sortableHeaders = [{ headerName: "Reference", sortName: "JOBID" },
    { headerName: "Product Description", sortName: "PRODUCTDESCRIPTION" },
    { headerName: "Product Name", sortName: "PRODUCTNAME" },
    { headerName: "Visit Location", sortName: "LOCATIONNAME" },
    { headerName: "Comp/Sch Date", sortName: "COMPLETEDSCHEDULEDDATE" },
    { headerName: "Scheduled For", sortName: "COMPLETEDSCHEDULEDDATE" },
    { headerName: "Internal Id", sortName: "PUBSJOBID" },
    { headerName: "Job Status", sortName: "STATE" },
    { headerName: "Due Date", sortName: "DUEDATE" },
    { headerName: "Status", sortName: "FLSSCHEDULEDSTATUS" },
    { headerName: "Asset Id", sortName: "ASSETREGISTRATION" },
    { headerName: "Asset Type", sortName: "ASSETTYPE" },
    { headerName: "Postcode", sortName: "POSTCODE" },
    { headerName: "Duration", sortName: "FLSCALLDURATION" },
    { headerName: "Assignee", sortName: "ASSIGNEENAME" },
    { headerName: "FLS Status", sortName: "FLSSTATUS" }];

    const allJobs = "All Jobs";
    const dateFilterReduxName = "jobListingDates";
    const jobLocationReduxName = "jobListingLocation";
    const jobSearchReduxName = "jobSearch";

    const reduxDates = useSelector(state => state.filters[dateFilterReduxName]);
    const reduxLocations = useSelector(state => state.filters[jobLocationReduxName]);
    const reduxSearch = useSelector(state => state.filters[jobSearchReduxName]);
    const dispatch = useDispatch();

    const [selectedLocations, setSelectedLocations] = useState([]);
    const locationListOnFilterOpen = useRef(selectedLocations);
    const currentPageNumber = useRef();
    const currentPageSize = useRef();
    const currentSearchTerm = useRef();
    const currentTableSortBy = useRef();
    const currentTableSortDir = useRef();
    const currentFilters = useRef();
    const currentStartDate = useRef();
    const currentEndDate = useRef();
    const currentLocationList = useRef();
    const [selectedJobsToEdit, setSelectedJobsToEdit] = useState([]);
    const [selectedJobsToCancel, setSelectedJobsToCancel] = useState([]);
    const selectedJobIdPrefix = "checkbox-";
    const [showBulkEditModal, setShowBulkEditModal] = useState(false);
    const [showBulkCancelModal, setShowBulkCancelModal] = useState(false);
    const [adminJobs, setAdminJobs] = useState([]);

    const defaultFilters = [
        { name: "UnallocatedJobs", value: allJobs, displayName: allJobs }
    ];

    useEffect(() => {
        setUpPage();
    }, []);

    useEffect(() => {
        var data = mapJobData([], adminJobs);
        setTableRows(data);
        setTableHeaders(getTableHeadersJobAdmin);
    }, [adminJobs, selectedJobsToEdit, selectAllJobs, selectAllJobsToCancel, selectedJobsToCancel]);

    useEffect(() => {
        validateAcknowledgedOnBehalfOf();
    }, [acknowledgedOnBehalfOf]);

    useEffect(() => {
        if (reload) {
            loadAdminScreenData(getFilters(), false);
        }
    }, [reload]);


    useEffect(() => {
        //This will trigger if the data changes, but will only process if the loadingData is set to true.
        if (loadingData && canAccessPage && 
            ((startDate && endDate) || (!startDate && !endDate)) &&
            locationSetUp && dateSetUp && selectedLocations != null) {

            let filtersArray = getFilters();
            var locationlist =  filtersArray.filter(cf => cf.key === 'Location').map(cf => cf.value).toString();
            var loadingValue = false;
            if (
                currentPageNumber.current !== pageNumber ||
                currentPageSize.current !== pageSize ||
                currentSearchTerm.current !== searchTerm ||
                currentTableSortBy.current !== tableSortBy ||
                currentTableSortDir.current !== tableSortDir ||
                currentFilters.current !== filtersArray.length ||
                currentStartDate.current !== startDate ||
                currentEndDate.current !== endDate ||
                currentLocationList.current !== locationlist
            ) {
                loadingValue = true;

                currentPageNumber.current = pageNumber;
                currentPageSize.current = pageSize;
                currentSearchTerm.current = searchTerm;
                currentTableSortBy.current = tableSortBy;
                currentTableSortDir.current = tableSortDir;
                currentFilters.current = filtersArray.length;
                currentStartDate.current = startDate;
                currentEndDate.current = endDate;
                currentLocationList.current = locationlist;

                loadAdminScreenData(filtersArray, true);
            }

            setLoadingData(loadingValue);
        }

    }, [loadingData, pageSize, pageNumber, tableSortBy, tableSortDir, appliedFilters, selectedLocations]);

    useEffect(() => {
        if (debouncedSearchTerm !== null && debouncedSearchTerm !== currentSearchTerm.current) {
            setPageNumber(1);
            setLoadingData(true);
        }
    }, [debouncedSearchTerm]);

    useEffect(() => {
        if (!loadingData) {
            dispatch(SetFiltering(jobLocationReduxName,
                {
                    list: selectedLocations
                }
            ));
        }
    }, [selectedLocations]);

    useEffect(() => {
        //We know the redux store has loaded now
        setDates();
    }, [reduxDates]);

    useEffect(() => {
        //We only want to set the locations once, else it gets stuck in a loop
        if (!locationSetUp) {
            setupLocationInfo();
        }
    }, [reduxLocations]);

    useEffect(() => {
        //We know the redux store has loaded now
        if (reduxSearch != null && reduxSearch.length > 0 && reduxSearch !== searchTerm) {
            setSearchTerm(reduxSearch);
        }
    }, [reduxSearch]);

    function loadAdminScreenData(filtersArray, resetSelectedjobs) {
        const jobsRequest = {
            requestCount: pageSize,
            pageNumber: pageNumber,
            sortField: tableSortBy.sortName,
            sortDirection: tableSortDir,
            filters: filtersArray
        };

        const loadDataPromises = [];

        var getJobsResponse = null;
        var assigneeResponse = null;

        const getJobs = JobService.getJobs(jobsRequest)
            .then(response => getJobsResponse = response);
        loadDataPromises.push(getJobs);

        const getJobAssigneeNames = JobService.getJobAssigneeNames(filtersArray)
            .then(response => assigneeResponse = response);
        loadDataPromises.push(getJobAssigneeNames);

        axios.all(loadDataPromises).then(function () {
            let data = [];

            if (getJobsResponse?.data != null) {
                setAdminJobs(getJobsResponse?.data);
            }
            else {
                setAdminJobs([]);
            }

            if (assigneeResponse != null) {
                setUpFilters(assigneeResponse);
            }

            setTotalRecords(getJobsResponse.totalCount);
            setLoadingData(false);
            focusOnTextBox(searchInputRef);
            if (resetSelectedjobs) {
                resetJobSelection();
            }
            else if (getJobsResponse?.data != null) {
                //if job is not in retrieved jobs then remove from selectedJobs
                let selectedJobsCopy = [...selectedJobsToEdit];
                selectedJobsCopy = selectedJobsCopy.filter(j => getJobsResponse?.data.some(a => a.jobId.toString() === j));
                setSelectedJobsToEdit(selectedJobsCopy);
            }

        }, function () {
            NotificationToaster.show(Intent.DANGER, "Visits could not be loaded. Please try loading the page again.");
            setLoadingData(false);
        });

    }

    function resetJobSelection() {
        setSelectAllJobs(false);
        setSelectedJobsToEdit([]);
    }
    function closeCancelModal(changesMade) {
        setShowBulkCancelModal(false);
        if (changesMade) {
            loadAdminScreenData(getFilters(), false);
            reloadRequired(1);
        }
    }
    function mapJobData(data, r) {
        data = r.map((d) => {
            let statusBlock = setupStatusBlock(d);
            let duration = '';

            if (d.flsCallDuration != null) {
                let hours = Math.floor(d.flsCallDuration / 60);
                let mins = d.flsCallDuration - (hours * 60);
                duration = hours + " hours " + mins + " mins";
            }

            let actionAcknowledge = null;
            //Can only acknowledge jobs with flsScheduledStatus (Fixed or Confirmed at time of writing this comment).
            if (d.flsScheduledStatus && !d.acknowledged && (d.amendmentType == null || d.amendmentType.length < 1)) {
                actionAcknowledge = <Tooltip content='Click to acknowledge visit.'><Button icon='plus' minimal={true} large={false} onClick={() => onAcknowledgeRowClick(d.jobId)}></Button></Tooltip>;
            }


                var pubsId = (d.pubsJobId == null || d.pubsJobId === 0) ? '' : d.pubsJobId;                               

                let row =  [(<Link to={`/job/${d.jobId}`} key={`job-link-${d.jobId}`}>{d.jobId}</Link>), d.productName,
                    statusBlock, pubsId, d.assetRegistration, d.assetType, d.locationName, d.postcode,
                <DateToLocal format='DD/MM/YYYY' key={`due-date-${d.jobId}`}>{d.dueDate}</DateToLocal>,
                    <DateToLocal hideTimeIfMidnight={ true} key={`comp-date-${d.jobId}`}>{d.completedScheduledDate}</DateToLocal>, duration,
                    d.state, d.assigneeName, d.flsStatus, <div className="button-row-small inline-items" key={`action-${d.jobId}`}>{actionAcknowledge}
                    </div>
                ];

                if (d.state === 'Awaiting Allocation') {
                    row.push(<FormCheckbox checked={selectedJobsToEdit.includes(d.jobId.toString())} onChange={(x) => toggleSelectRow(x)} key={`${selectedJobIdPrefix}${d.jobId}`} id={`${selectedJobIdPrefix}${d.jobId}`} />)
                }
                else {
                    row.push(<Fragment></Fragment>);
                }

                if (JobHelperFunctions.canCancel(d)) {
                    row.push(<FormCheckbox checked={selectedJobsToCancel.includes(d.jobId.toString())} onChange={(x) => toggleSelectRowToCancel(x)} key={`${selectedJobIdPrefix}${d.jobId}`} id={`${selectedJobIdPrefix}${d.jobId}`} />);
                }
                else {
                    row.push(<Fragment></Fragment>,)
                }

                return row;
        });
        return data;
    }

    function resetCurrent() {
        currentPageNumber.current = null;
        currentPageSize.current = null;
        currentSearchTerm.current = null;
        currentTableSortBy.current = null;
        currentTableSortDir.current = null;
        currentFilters.current = null;
        currentStartDate.current = null;
        currentEndDate.current = null;
    }

    function getTableHeadersJobAdmin() {
        return ["Reference", "Product Name", "Status", "Internal Id", "Asset Id", "Asset Type", "Visit Location", "Postcode", "Due Date", "Comp/Sch Date", "Duration", "Job Status", "Assignee", "FLS Status",
            "Action", <div key="act-list-select-all" className="form-field">Edit<FormCheckbox key="header-admin-checkbox" checked={selectAllJobs} disabled={isLoading} onChange={(x) => toggleSelectAllAdminView(x)} /></div>,
            <div key="act-list-select-cancel" className="form-field">Cancel<FormCheckbox key="header-admin-checkbox-cancel" checked={selectAllJobsToCancel} disabled={isLoading} onChange={(x) => toggleSelectAllToCancelAdminView(x)} /></div>
        ];
 
    }

    function setUpPage() {
        dispatch({ type: 'SITE_FULL_WIDTH' });
        setTableHeaders(getTableHeadersJobAdmin());
    }

    function setUpFilters(assignees) {

        var selectedAssignees = appliedFilters.filter(a => a.name === "AssigneeName" && a.value !== "Unassigned").map(function (f) {
            return f.value;
        });

        var itemAssignees = assignees.map(a => { return { "id": a, "name": a } });

        var reorderNeeded = false;
        selectedAssignees.forEach((item) => {
            if (!itemAssignees.some(obj => obj["id"] === item)) {
                itemAssignees.push({ "id": item, "name": item });
                reorderNeeded = true;
            }
        });

        if (reorderNeeded) {
            itemAssignees = itemAssignees.sort((a, b) => a.name.localeCompare(b.name));
        }

        itemAssignees.unshift({ "id": "Unassigned", "name": "Unassigned" });


        var filterArray = [filters[0], filters[1]];
        filterArray.push({
            "displayName": "Assignee Names", "name": "AssigneeName", "items": [
                ...itemAssignees
            ]
        });
        filterArray.push(filters[2]);
        filterArray.push(filters[flsStatusFilter]);
        
        setPageFilters(filterArray);
        
    }
     
    function getFilters(){
        let mappedFilters = appliedFilters.map(function (f) {
            return {
                key: f.name,
                ...f
            }
        });

        let filtersArray = [...mappedFilters,
            { "key": "Search", "value": searchTerm }
        ];

        if (startDate && endDate) {
            filtersArray = [...filtersArray,
            { "key": "CompletedScheduledStartDate", "value": startDate },
            { "key": "CompletedScheduledEndDate", "value": endDate }
            ];
        }

        if (selectedLocations != null) {
            selectedLocations.forEach(function (l) {
                filtersArray = [...filtersArray,
                { "key": "Location", "value": l }
                ];
            });
        }

        return filtersArray;
    }

    function setupStatusBlock(jobRow) {
        let statusBlockTooltip = null;
        let scheduledStatus = null;
        let scheduledHollow = false;
        let schedueledText = "Scheduled"
        let statusBlock = null;
        if (jobRow.flsScheduledStatus) {
            if (jobRow.amendmentType != null && jobRow.amendmentType.length > 0) {
                if (jobRow.amendmentType === 'Amendment') {
                    statusBlockTooltip = <span>Pending {jobRow.amendmentType.toLowerCase()} to <DateToLocal format='DD/MM/YYYY'>{jobRow.rescheduleDate}</DateToLocal> requested by {jobRow.amendmentBy} on <DateToLocal format='DD/MM/YYYY'>{jobRow.amendmentDate}</DateToLocal>.</span>
                } else {
                    statusBlockTooltip = <span>Pending {jobRow.amendmentType.toLowerCase()} requested by {jobRow.amendmentBy} on <DateToLocal format='DD/MM/YYYY'>{jobRow.amendmentDate}</DateToLocal>.</span>
                }
            } else if (jobRow.acknowledged) {
                statusBlockTooltip = <span>Acknowledged by {jobRow.acknowledgedBy} on <DateToLocal format='DD/MM/YYYY'>{jobRow.acknowledgedDate}</DateToLocal>.</span>
            } else {
                statusBlockTooltip = <span>Awaiting acknowledgement.</span>
            }

            if (jobRow.amendmentType != null) {
                scheduledStatus = jobRow.amendmentType === 'Amendment' ? 'Amber' : 'Red';
                schedueledText = jobRow.amendmentType === 'Amendment' ? 'Amendment' : 'Cancellation';
            } else {
                scheduledHollow = !jobRow.acknowledged;
            }
            statusBlock = <Tooltip content={statusBlockTooltip}>
                <StatusBlock status={scheduledStatus} hollow={scheduledHollow} bold={false} large={false}>{schedueledText}</StatusBlock>
            </Tooltip>;
        }
        return statusBlock;
    }

    function setDates() {
        if (reduxDates && reduxDates.startDate !== null && reduxDates.endDate !== null) {
            setStartDate(moment(reduxDates.startDate).format("YYYY-MM-DD"));
            setEndDate(moment(reduxDates.endDate).format("YYYY-MM-DD"));
        } else if (dateSetUp) {
            setStartDate(null);
            setEndDate(null);
        }
        else {
            let defaultdays = 60;
            setStartDate(moment().add(defaultdays * -1, 'd').format("YYYY-MM-DD"));
            setEndDate(moment().add(defaultdays, 'd').format("YYYY-MM-DD"));
        }
        setDateSetUp(true);
        setLoadingData(true);
    }

    function setupLocationInfo() {
        LocationService.getFormLocationSelectorCustomLocations(['Tacho', 'Vis', 'Audit']).then(function (locations) {
            setLocationList(locations);
            var clonedlocations = HelperFunctions.deepClone(locations);
            setBulkEditLocationList(clonedlocations);
            setLocationSetUp(true);
            if (reduxLocations != null && reduxLocations.list.length > 0) {
                setSelectedLocations(reduxLocations.list);
            } else {
                setSelectedLocations(locations.location[0].items.map(l => l.id));
            }
        }, function (error) {
            NotificationToaster.show(Intent.DANGER, `Locations failed ${error}`);
        });
        setLoadingData(true);
    }

    function validateAcknowledgedOnBehalfOf() {
        let acknowledgedRules = [];
        if (isInternal) {
            acknowledgedRules = [{ fieldName: "acknowledgedOnBehalfOf", required: true }];
        }
        validate(acknowledgedRules, acknowledgedOnBehalfOf);
    }

    function onPagingChange(newPageNumber, newPageSize) {
        setPageNumber(newPageNumber);
        setPageSize(newPageSize);
        setLoadingData(true);
    }

    function onTableSort(header, direction) {
        setTableSortBy(header);
        setTableSortDir(direction);
        setLoadingData(true);
    }

    function onToggleFilter() {
        setShowFilters((prevState) => {
            return !prevState;
        })
    }

    function closeBulkEditModal(response){
        setShowBulkEditModal(false);

        if (!response.isActivated && !response.isUpdated) {
            return;
        }
        loadAdminScreenData(getFilters(), false);
        reloadRequired(1);
    }

    function onFilterChange(listingFilters) {
        setLoadingData(true);
        setPageNumber(1);
        setAppliedFilters(listingFilters);
    }

    function onDateRangeChange(item) {
        if ((item?.startDate?.date != null && item?.endDate?.date != null) || (item?.startDate?.date == null && item?.endDate?.date == null)) {
            setPageNumber(1);

            //Using the redux store should mean the setDates is called
            dispatch(SetFiltering(dateFilterReduxName, {
                startDate: item.startDate?.date,
                endDate: item.endDate?.date
            }));
        }
    }

    function onLocationListOpened() {
        locationListOnFilterOpen.current = selectedLocations;
    }

    function onLocationListClose() {
        if (locationListOnFilterOpen.current.toString() !== selectedLocations.toString()) {
            setLoadingData(true);
        }
    }

    function onAcknowledgeRowClick(jobId) {
        setCurrentJobId(jobId);
        validateAcknowledgedOnBehalfOf();
        setShowAcknowledge(true);
        focusOnTextBox(acknowledgedOnBehalfOfInputRef);
    }

    function focusOnTextBox(InputRef) {
        setTimeout(function () {
            if (InputRef.current != null) {
                InputRef.current.focus();
            }
        });
    }

    function toggleSelectAllAdminView(e) {
        let checked = e.target.checked;
        setSelectAllJobs(checked);

        //Adding or removing the activity from the selected activities list
        if (checked) {
            var jobIds = adminJobs
                .filter(x => x.state === 'Awaiting Allocation')
                .map(j => j.jobId.toString());
            setSelectedJobsToEdit(jobIds);
        }
        else {
            setSelectedJobsToEdit([]);
        }
    }

    function toggleSelectAllToCancelAdminView(e) {
        let checked = e.target.checked;
        setSelectAllJobsToCancel(checked);

        //Adding or removing the activity from the selected activities list
        if (checked) {
            var jobIds = adminJobs
                .filter(x => JobHelperFunctions.canCancel(x))
                .map(j => j.jobId.toString());
            setSelectedJobsToCancel(jobIds);
        }
        else {
            setSelectedJobsToCancel([]);
        }
    }
    function toggleSelectRow(e) {
        let { id, checked } = e.target;
        var jId = id.substring(selectedJobIdPrefix.length);
        onJobCheckChange(jId, checked);
    }
    
    function onJobCheckChange(jobId, checked) {
        var clonedSelectedJobs = [
            ...selectedJobsToEdit
        ];

        //Adding or removing the activity from the selected activities list
        if (checked) {
            if (clonedSelectedJobs.indexOf(jobId) < 0) {
                clonedSelectedJobs = [...clonedSelectedJobs, jobId];
            }
        }
        else {
            clonedSelectedJobs = clonedSelectedJobs.filter(j => j !== jobId); 
        }
        setSelectedJobsToEdit(clonedSelectedJobs);
    }

    function toggleSelectRowToCancel(e) {
        let { id, checked } = e.target;
        var jId = id.substring(selectedJobIdPrefix.length);
        onJobToCancelCheckChange(jId, checked);
    }

    function onJobToCancelCheckChange(jobId, checked) {
        var clonedSelectedJobsToCancel = [
            ...selectedJobsToCancel
        ];

        //Adding or removing the activity from the selected activities list
        if (checked) {
            if (clonedSelectedJobsToCancel.indexOf(jobId) < 0) {
                clonedSelectedJobsToCancel = [...clonedSelectedJobsToCancel, jobId];
            }
        }
        else {
            clonedSelectedJobsToCancel = clonedSelectedJobsToCancel.filter(j => j !== jobId);
        }
        setSelectedJobsToCancel(clonedSelectedJobsToCancel);
    }

    function closeAcknowledge(reloadValue) {
        validate([], {});
        if (isInternal) {
            setAcknowledgedOnBehalfOf((prevValue) => {
                return {
                    ...prevValue,
                    acknowledgedOnBehalfOf: null
                }
            });
        }
        setSavingData(false);
        if (reloadValue) {
            setLoadingData(true);
        }
        setShowAcknowledge(false);
    }

    function onAcknowledgeConfirm() {
        validateAcknowledgedOnBehalfOf();
        if (isValid) {
            setSavingData(true);
            JobService.acknowledgeJob(currentJobId, isInternal ? acknowledgedOnBehalfOf : { acknowledgedOnBehalfOf: null }).then(function () {
                resetCurrent();
                closeAcknowledge(true);
                NotificationToaster.show(Intent.SUCCESS, "Visit acknowledged successfully");
            },
                (error) => {
                    closeAcknowledge(false);
                    NotificationToaster.show(Intent.DANGER, error);
                }
            );
        }
    }

    function onAcknowledgeCancel() {
        closeAcknowledge(false);
    }

    function onAcknowledgedOnBehalfOfChange(item) {
        setAcknowledgedOnBehalfOf((prevValue) => {
            return {
                ...prevValue,
                acknowledgedOnBehalfOf: item.target.value
            }
        });
    }


    function onSearchChange(item) {
        setSearchTerm(item.target.value);
        dispatch(SetFiltering(jobSearchReduxName, item.target.value));
    }


    return (
        <UserAccess perform={requiredAction}
            yes={() => (
                <div className="row">

                    <ShowHide
                        evaluator={tableRows.length === 0 && !loadingData && pageFilters.length === 0}
                        hide={(
                            <Fragment>
                                <div className="filter-controls">
                                    <div className="inline-items">
                                        <div className="inline-item fill">
                                            <div className="form-field-full">
                                                <FormTextInput
                                                    maxLength={50}
                                                    inputRef={searchInputRef}
                                                    placeholder="Product or Reference"
                                                    onChange={onSearchChange}
                                                    value={searchTerm}
                                                    large
                                                    disabled={loadingData}
                                                    icon="search"
                                                    id="job-search-field" />
                                            </div>
                                        </div>
                                        <FormLocationSelector
                                            businessArea={""}
                                            loading={loadingData}
                                            selectedLocations={selectedLocations}
                                            setSelectedLocations={setSelectedLocations}
                                            useHierarchy={false}
                                            useLocationDefaults={false}
                                            locationDefaultsToTrue={true}
                                            onLocationListClose={onLocationListClose}
                                            onLocationListOpened={onLocationListOpened}
                                            customLocations={locationList}
                                            useCustomLocations={true}
                                        />
                                        <FormDateRangeInput
                                            onChange={onDateRangeChange}
                                            startDate={startDate}
                                            endDate={endDate}
                                            disabled={loadingData}
                                            headingText={""}
                                            large
                                        ></FormDateRangeInput>

                                        <div key="act-list-select-all" className="form-field">
                                            <Button text="Bulk Edit" onClick={() => { setShowBulkEditModal(true); }} disabled={selectedJobsToEdit.length === 0}></Button>
                                        </div>
                                        <div key="act-list-select-cancel" className="form-field">
                                            <Button text="Bulk Cancel" onClick={() => { setShowBulkCancelModal(true); }} disabled={selectedJobsToCancel.length === 0}></Button>
                                        </div>   
                                        <Fragment>
                                            <FilterButton onToggle={onToggleFilter} filters={appliedFilters} />
                                        </Fragment>                                 
                                    </div>
                                    <Filter filterName="reviews" visible={showFilters} filters={pageFilters} onUpdate={onFilterChange} defaultFilterValues={defaultFilters} onClickOutside={onToggleFilter} />
                                </div>
                                
                                <BulkEditJob jobs={selectedJobsToEdit} locations={bulkEditlocationList} loading={loadingData} showBulkEditModal={showBulkEditModal} closeBulkEditModal={closeBulkEditModal}></BulkEditJob>
                            </Fragment>
                        )}
                    />

                        <Fragment>
                            <ListingTable
                                id="listing-table-location"
                                headers={tableHeaders}
                                data={tableRows}
                                totalRecordCount={totalRecords}
                                onPagingChange={onPagingChange}
                                loadingData={loadingData}
                                noDataMessage={noDataMessage}
                                sortable
                                sortableHeaders={sortableHeaders}
                                sortedBy={tableSortBy}
                                sortedDir={tableSortDir}
                                onSort={onTableSort}
                                />

                <AlertConfirm
                    title="Please confirm acknowledgement"
                    isOpen={showAcknowledge}
                    saving={loadingData || savingData}
                    onConfirm={onAcknowledgeConfirm}
                    onCancel={onAcknowledgeCancel}
                    disabled={!isValid}
                >
                    <ShowHide
                        evaluator={!isInternal}
                        hide={(
                            <Fragment>
                                <FormTextInput
                                    id="acknowledged-on-behalf-of"
                                    headingText="Acknowledged on behalf of:"
                                    placeholder="Employee name"
                                    value={acknowledgedOnBehalfOf.acknowledgedOnBehalfOf}
                                    large
                                    maxLength={255}
                                    onChange={onAcknowledgedOnBehalfOfChange}
                                    dangerHelperText={errors.acknowledgedOnBehalfOf}
                                    inputRef={acknowledgedOnBehalfOfInputRef}
                                />
                            </Fragment>
                        )}
                    />
                    <p>Are you sure you want to acknowledge this visit, it will no longer appear on the daily email reminder?</p>
                </AlertConfirm>
                            <CancelJob
                                showCancelModal={showBulkCancelModal}
                                closeCancelModal={closeCancelModal}
                                jobIds={selectedJobsToCancel}
                                loading={loadingData}
                                showJobDetails={true}
                            />        
                        </Fragment>

                </div>
            )}
            no={() => (
                <PageRestricted />
            )}
        />
    );
}

JobListingStandard.propTypes = {
    locations: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    filters: PropTypes.array,
    reloadDone: PropTypes.func,
    reloadRequired: PropTypes.func,
    reload: PropTypes.bool.isRequired,
};